import { cn, formatBillingCurrency, isNegativeBillingAmount } from '@/lib/utils';

export const BillingAmount = ({ value, className }: { value: number; className?: string }) => (
  <span className={cn(className, isNegativeBillingAmount(value) && 'text-destructive')}>
    {formatBillingCurrency(value)}
  </span>
);
